import { defineComponent as _defineComponent } from 'vue'
import OnboardingStep from '@/modules/onboarding/OnboardingStep.vue';
import {TourName} from '@/modules/onboarding/tour/models/TourOptions';
import {TourStep} from '@/modules/onboarding/tour/models/TourStep';
import {onKeyStroke} from '@vueuse/core';
import {computed, getCurrentInstance} from 'vue';
import {Tour} from '@/modules/onboarding/tour/Tour';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingContainer',
  props: {
    tourName: null,
    steps: null
  },
  setup(__props: any) {

const props = __props as {
  tourName: TourName,
  steps: TourStep[],
}



const OPTIONS = {
  // disable the default keyboard navigation
  useKeyboardNavigation: false,
};

const instance = getCurrentInstance();
const onboarding = computed<Tour>(() => instance!.proxy.$onboarding.tours[props.tourName]);

onKeyStroke('ArrowLeft', () => {
  onboarding.value.previousStep();
});

onKeyStroke('ArrowRight', () => {
  onboarding.value.nextStep();
});

return { __sfc: true,props, OPTIONS, instance, onboarding, OnboardingStep }
}

})